import { render, staticRenderFns } from "./ConfirmWithCommentModal.vue?vue&type=template&id=e48196e6&scoped=true"
import script from "./ConfirmWithCommentModal.vue?vue&type=script&lang=js"
export * from "./ConfirmWithCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48196e6",
  null
  
)

export default component.exports